<div [class]="toggleSidebar ? 'sidbar_toggle sidebar_container' : 'sidebar_container'" data-testid="sidebar" *ngIf="hideComponent()">
  <div class="logo_img">
    <img class="big_logo" src="assets/images/Logo-Volta.svg" alt="">
    <img class="smal_logo" src="assets/images/small_logo.svg" alt="">
    <img class="logo_responsive" src="assets/icones/Logo-responsive.svg" alt="">
    <div class="toggel_sidebar_container">
      <button type="button" class="toggel_sidebar" (click)="toggle('sidebar')" [attr.aria-label]="'Toggle sidebar'">
        <ui-icon name="PanelLeft" size="large"></ui-icon>
      </button>
    </div>
  </div>
  <div class="list_modules">
    <!-- Orders / Smart Inbox sit ungrouped at the top — no category heading (WB-7455). -->
    <div class="module_container">
      <a ui-nav-item class="module" data-testid="nav-quotations" routerLink="/quotations"
        [matTooltip]="'quotations_and_orders.order' | translate"
        matTooltipPosition="right"
        [matTooltipDisabled]="!isCollapsed"
        routerLinkActive="active"
        *appHasPermission="{ module: 'order' }"
      >
        <ui-icon name="ShoppingBag"></ui-icon>
        <span class="title">{{"quotations_and_orders.order" | translate}}</span>
      </a>
      <a ui-nav-item class="module" data-testid="nav-smart-inbox" routerLink="/smart-inbox"
        [matTooltip]="'smart_inbox.title' | translate"
        matTooltipPosition="right"
        [matTooltipDisabled]="!isCollapsed"
        routerLinkActive="active"
        *appHasPermission="{ module: 'smart_inbox' }"
      >
        <ui-icon name="Mail"></ui-icon>
        <span class="title">{{"smart_inbox.title" | translate}}</span>
      </a>
    </div>

    <ui-nav-section
      [label]="'import.product' | translate"
      [collapsed]="!!toggleProduits"
      (toggled)="toggle('produits')">
    </ui-nav-section>
    <div class="module_container" *ngIf="!toggleProduits">
      <!-- WB-5071: Import link hidden — feature not currently in use -->
      <!-- <a ui-nav-item class="module" routerLink="/imports"
        routerLinkActive="active"
      >
        <ui-icon name="Download"></ui-icon>
        <span class="title">{{"import.import" | translate}}</span>
      </a> -->
      <a ui-nav-item class="module" data-testid="nav-inventory" routerLink="/inventory"
        [matTooltip]="'inventory.inventory' | translate"
        matTooltipPosition="right"
        [matTooltipDisabled]="!isCollapsed"
        routerLinkActive="active"
      >
        <ui-icon name="Package"></ui-icon>
        <span class="title">{{"inventory.inventory" | translate}}</span>
      </a>
      <a ui-nav-item class="module" data-testid="nav-organize" [appActiveLink]="['/organize/brands', '/organize/categories', '/organize/tags']" routerLink="/organize/brands"
        [matTooltip]="'organize.organize' | translate"
        matTooltipPosition="right"
        [matTooltipDisabled]="!isCollapsed"
      >
        <ui-icon name="LayoutGrid"></ui-icon>
        <span class="title">{{"organize.organize" | translate}}</span>
      </a>
      <a ui-nav-item class="module" data-testid="nav-catalogs" routerLink="/catalogs"
        [matTooltip]="'Catalogs.catalogs' | translate"
        matTooltipPosition="right"
        [matTooltipDisabled]="!isCollapsed"
        routerLinkActive="active"
      >
        <ui-icon name="Clipboard"></ui-icon>
        <span class="title">{{"Catalogs.catalogs" |translate}}</span>
      </a>
    </div>

    <ui-nav-section
      [label]="'customers.customers' | translate"
      [collapsed]="!!toggleCustomers"
      (toggled)="toggle('customers')">
    </ui-nav-section>
    <div class="module_container" *ngIf="!toggleCustomers">
      <a ui-nav-item class="module" data-testid="nav-companies" routerLink="/companies"
        [matTooltip]="'companies.company' | translate"
        matTooltipPosition="right"
        [matTooltipDisabled]="!isCollapsed"
        routerLinkActive="active"
      >
        <ui-icon name="Store"></ui-icon>
        <span class="title">{{"companies.company" | translate}}</span>
      </a>

      <a ui-nav-item class="module" data-testid="nav-companies-groups" routerLink="/companies-groups"
        [matTooltip]="'companies_groups.companies_groups' | translate"
        matTooltipPosition="right"
        [matTooltipDisabled]="!isCollapsed"
        routerLinkActive="active"
      >
        <ui-icon name="List"></ui-icon>
        <span class="title">{{"companies_groups.companies_groups" | translate}}</span>
      </a>
      <!-- WB-5071: Segments link hidden — feature not currently in use -->
      <!-- <a ui-nav-item class="module" routerLink="/segments"
        routerLinkActive="active">
        <ui-icon name="Target"></ui-icon>
        <span class="title">{{"segment.segments" | translate}}</span>
      </a> -->
    </div>

    <!-- WB-5071: Salesforce/Agents section hidden — feature not currently in use -->
    <!-- <ui-nav-section
      [label]="'agent.sidebar.separator' | translate"
      [collapsed]="!!toggleSalesforce"
      (toggled)="toggle('salesforce')">
    </ui-nav-section>

    <div class="module_container" *ngIf="!toggleSalesforce">
      <a ui-nav-item class="module" routerLink="/agents"
        routerLinkActive="active"
      >
        <ui-icon name="Briefcase"></ui-icon>
        <span class="title">{{"agent.title" | translate}}</span>
      </a>
    </div> -->

    <!-- Pricebook/loyalty MARKETING section hidden front-end-wide due to business decision (WB-6694).
         Not deleted — gated by loyaltyEnabled, which is forced to false in FeatureFlagService. -->
    <ng-container *ngIf="loyaltyEnabled">
      <ui-nav-section
        [label]="'pricebook.sidebar.module' | translate"
        [collapsed]="!!toggleMarketing"
        (toggled)="toggle('marketing')">
      </ui-nav-section>

      <div class="module_container" *ngIf="!toggleMarketing">
        <a ui-nav-item class="module" routerLink="/pricebook"
          [matTooltip]="'pricebook.title' | translate"
          matTooltipPosition="right"
          [matTooltipDisabled]="!isCollapsed"
          routerLinkActive="active"
        >
          <ui-icon name="Gift"></ui-icon>
          <span class="title">{{"pricebook.title" | translate}}</span>
        </a>
      </div>
    </ng-container>

    <!-- WB-5071: Purchase/Comparator section hidden — feature not currently in use -->
    <ui-nav-section
      *ngIf="false"
      [label]="'comparator.purchase' | translate"
      [collapsed]="!!togglePurchase"
      (toggled)="toggle('purchase')">
    </ui-nav-section>

    <div class="module_container" *ngIf="false && !togglePurchase">
      <a ui-nav-item class="module" routerLink="/comparators"
        [matTooltip]="'comparator.comparator' | translate"
        matTooltipPosition="right"
        [matTooltipDisabled]="!isCollapsed"
        routerLinkActive="active"
      >
        <ui-icon name="GitCompare"></ui-icon>
        <span class="title">{{"comparator.comparator" | translate}}</span>
      </a>
      <!-- <a ui-nav-item class="module" routerLink="/suppliers"
       [appActiveLink]="['/suppliers', '/suppliers/add', '/suppliers/{{currentId}}']">
        <ui-icon name="Truck"></ui-icon>
        <span class="title">{{"suppliers.suppliers" | translate}}</span>
      </a> -->
    </div>

    <ui-nav-section
      class="last_block"
      [label]="'settings.account' | translate"
      [collapsed]="!!toggleSettings"
      (toggled)="toggle('settings')">
    </ui-nav-section>
    <div class="module_container last_block_sidebar" *ngIf="!toggleSettings">
      <a ui-nav-item class="module sidebar__notification-bell" data-testid="nav-notifications" [matMenuTriggerFor]="notificationMenu"
        [matTooltip]="'notifications.title' | translate"
        matTooltipPosition="right"
        [matTooltipDisabled]="!isCollapsed"
      >
        <ui-icon name="Bell"></ui-icon>
        <span class="title">{{"notifications.title" | translate}}</span>
        <span class="ui-nav-item__badge" *ngIf="unreadCount > 0">
          {{ unreadCount > 99 ? '99+' : unreadCount }}
        </span>
      </a>
      <a ui-nav-item class="module" data-testid="nav-workflows" routerLink="/workflows"
        [matTooltip]="'workflows.title' | translate"
        matTooltipPosition="right"
        [matTooltipDisabled]="!isCollapsed"
        routerLinkActive="active"
        *appHasPermission="{ module: 'workflow' }">
        <ui-icon name="Zap"></ui-icon>
        <span class="title">{{"workflows.title" | translate}}</span>
      </a>
      <mat-menu #notificationMenu="matMenu" class="notification-menu" xPosition="after" yPosition="above" [overlapTrigger]="false">
        <ng-template matMenuContent>
          <app-notification-panel (closed)="notificationMenu.closed.emit()"></app-notification-panel>
        </ng-template>
      </mat-menu>
      <a ui-nav-item class="module" data-testid="nav-knowledge-base" routerLink="/knowledge-base" routerLinkActive="active"
        [matTooltip]="'knowledge_base.title' | translate"
        matTooltipPosition="right"
        [matTooltipDisabled]="!isCollapsed"
        *appHasPermission="{ module: 'knowledge_base' }">
        <ui-icon name="Book"></ui-icon>
        <span class="title">{{ 'knowledge_base.title' | translate }}</span>
      </a>
      <a ui-nav-item class="module" data-testid="nav-settings" routerLink="/settings" routerLinkActive="active"
        [matTooltip]="'settings.settings' | translate"
        matTooltipPosition="right"
        [matTooltipDisabled]="!isCollapsed"
      >
        <ui-icon name="Settings"></ui-icon>
        <span class="title">{{"settings.settings" | translate}}</span>
      </a>
    </div>
  </div>

  <!-- Signed-in user + icon-only logout. Collapsed: only the logout icon. -->
  <ui-sidebar-footer [collapsed]="toggleSidebar" (logout)="logout()"></ui-sidebar-footer>
</div>
